module.exports = __webpack_public_path__ + "components/advertise-header/static/c__card--1@2-c944193e378c3aeb712eb18f4f34b248.jpg";